export default {
  'signin': 'Signin',
  'signin-action': 'Sign in',
  'forgot-password': 'Forgotten password ?',
  'ask-new-password': 'Reset password',
  'reset-password': 'New password',
  'save-password': 'Save',
  'invalid-mail': 'Please enter a valid email address',
  'password-check': 'Your password must contain at least one digit, one upper case, one lower case and 8 characters'
}



// WEBPACK FOOTER //
// ./src/translations/en/authentification.js